// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"321":"c9146f0d","734":"7a76ecd8","978":"b535c902"}[chunkId] + ".css";
};